<div class="alert" *ngIf="error && errorMessage">{{ errorMessage }}</div>
